module.exports = __webpack_public_path__ + "static/busines_analysis_and_value_targeting-6cec9dfef5151fe1e20f7e1620d8e31b.jpg";